// import React, { useState, useEffect, useContext } from "react";
// import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
// import { useTheme } from "@emotion/react";
// import AppModal from "../../../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";

// import Tab4MonthlyEnergyTabs from "./Tab4MonthlyEnergyTabs";



// export default function Tab4MonthlyEnergy() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const { palette } = useTheme();
//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

   
//     return (

//         <>
//             <div className="row">

//                 <div className="col-md-12">

                    

//                     {loading && <p>Loading chart data...</p>}
//                     {error && <p style={{ color: "red" }}>{error}</p>}
//                     {!loading && !error && (
//                         <>
//                             <InvverterFullSize title={``} onFullScreen={handleOpenMix} />
//                            <Tab4MonthlyEnergyTabs/>
//                             <AppModal open={OpenMix} handleClose={handleCloseMix}>
//                             <Tab4MonthlyEnergyTabs/>

//                             </AppModal>
//                         </>
//                     )}
//                 </div>
//             </div>


//         </>


//     );
// }





import React, { useState, useContext } from "react";
import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import AppModal from "../../../../../../../components/AppModal";
import Tab4MonthlyEnergyTabs from "./Tab4MonthlyEnergyTabs";

export default function Tab4MonthlyEnergy() {
  const { PrimaryColor } = useContext(AppThemeContext);
  const { palette } = useTheme();
  const [OpenMix, setOpenMix] = useState(false);
  const handleOpenMix = () => setOpenMix(true);
  const handleCloseMix = () => setOpenMix(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  return (
    <div className="row">
      <div className="col-md-12">
        {loading && <p>Loading chart data...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {!loading && !error && (
          <>
            {/* Normal view */}
            <Tab4MonthlyEnergyTabs onFullScreen={handleOpenMix} />

            {/* Fullscreen view inside AppModal */}
            <AppModal open={OpenMix} handleClose={handleCloseMix}>
              <Tab4MonthlyEnergyTabs onFullScreen={handleCloseMix} />
            </AppModal>
          </>
        )}
      </div>
    </div>
  );
}

